export const BRAND_PRIMARY = "#ff7b00";
export const BRAND_ACCENT = "#00daf3";

export const labelStyle = {
    display: "block",
    fontSize: "12px",
    fontWeight: "500" as const,
    color: "#b79e91",
    marginBottom: "6px",
    fontFamily: "'Space Grotesk', 'Inter', sans-serif",
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
};

export const inputStyle = { fontSize: "14px", padding: "10px 12px" };
